import * as React from 'react';
import { AppUser } from '../../../../../views/App/App';
import { AfterSchoolClubProgramme } from '../../../../../models/clubProgramme';
import { ClubProgrammeAddClubsContent } from '../ClubProgrammeAddClubsContent';

type Props = {
  isOpen: boolean;
  user: AppUser;
  programme: AfterSchoolClubProgramme;
  onClose: () => void;
  onProgrammeUpdated: (programme: AfterSchoolClubProgramme) => void;
};

export const ClubProgrammeAddClubsModal: React.FC<Props> = ({
  isOpen,
  user,
  programme,
  onClose,
  onProgrammeUpdated
}) => {
  if (!isOpen) return null;

  return (
    <div className="pcAddModalOverlay" onClick={onClose}>
      <ClubProgrammeAddClubsContent
        user={user}
        programme={programme}
        variant="modal"
        onClose={onClose}
        onProgrammeUpdated={onProgrammeUpdated}
      />
    </div>
  );
};
